import { writable } from 'svelte/store';

export const cart = writable(JSON.parse(cartJson))
export const lang = writable(langJson)
export const comment = writable(commentJson)
export const currency = writable(currencyJson)


